import { InitialValues } from 'forms/types';

import { DepressionFormValues, Severity } from '../form/types';
import { DepressionProfileQuery } from '../graphql/DepressionProfile';

const buildInitialValues = (data?: DepressionProfileQuery): InitialValues<DepressionFormValues> => {
  const depressionProfile = data?.depression;

  return {
    diagnosedAt: depressionProfile?.diagnosedAt,
    severity: depressionProfile?.severity as Severity,
    currentlyTreated: depressionProfile?.currentlyTreated,
    everTreated: depressionProfile?.everTreated,
    treatmentEndDate: depressionProfile?.treatmentEndDate,
    numberOfMedications: depressionProfile?.numberOfMedications,
    psychotherapy: depressionProfile?.psychotherapy,
    hospitalized: depressionProfile?.hospitalized,
    hospitalizedAt: depressionProfile?.hospitalizedAt,
  };
};

export default buildInitialValues;
